export enum FileTypes {
  SHAPEFILE = 'Shapefile',
  RASTER = 'Raster',
  GEOJSON = 'GeoJSON',
  WMS = 'Web Map Service',
  KML = 'Kml',
  KMZ = 'Kmz',
}

export const FileTypeExtensionDefinitions = {
  [FileTypes.SHAPEFILE]: '.shp',
  [FileTypes.RASTER]: '.tif',
  [FileTypes.GEOJSON]: '.geojson',
  [FileTypes.WMS]: 'wms',
  [FileTypes.KML]: '.kml',
  [FileTypes.KMZ]: '.kmz',
};
